import { render, staticRenderFns } from "./ReincageProduct.vue?vue&type=template&id=56826b79&scoped=true&"
import script from "./ReincageProduct.vue?vue&type=script&lang=js&"
export * from "./ReincageProduct.vue?vue&type=script&lang=js&"
import style0 from "./ReincageProduct.vue?vue&type=style&index=0&id=56826b79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56826b79",
  null
  
)

export default component.exports